module.exports = __webpack_public_path__ + "media/47.5f63bfd6.mp3";